<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-video3-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-video3-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.4962903209925;"
    data-aspect-ratio="0.496"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-video3-xs-img"
      class="g-video3-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video3-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.4874%;margin-top:-8.5px;left:76.3734%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:8.9605%;margin-top:-17.6px;right:15.7175%;width:112px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
      <p class="g-pstyle1">draws the gun.</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:14.5249%;margin-top:-17.6px;right:50.1798%;width:116px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
      <p class="g-pstyle1">moves forward.</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.0246%;margin-top:-8.5px;left:76.395%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:42.7984%;margin-top:-17.6px;left:68.2719%;margin-left:-62.5px;width:125px;"
    >
      <p class="g-pstyle2">Steps to the side</p>
      <p class="g-pstyle2">of the car.</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.6145%;margin-top:-8.5px;left:76.402%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:78.5163%;margin-top:-9.1px;left:70.5853%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle2">First shot</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-video3-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.76699413244296;"
    data-aspect-ratio="0.767"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-video3-sm-img"
      class="g-video3-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video3-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.4874%;margin-top:-8.5px;left:67.4426%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:8.9605%;margin-top:-17.6px;right:27.3619%;width:129px;"
    >
      <p class="g-pstyle1">ICE agent 1 draws</p>
      <p class="g-pstyle1">the gun.</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:14.5249%;margin-top:-17.6px;right:49.7388%;width:116px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
      <p class="g-pstyle1">moves forward.</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.0246%;margin-top:-8.5px;left:67.4565%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:42.7984%;margin-top:-17.6px;left:62.2003%;margin-left:-62.5px;width:125px;"
    >
      <p class="g-pstyle2">Steps to the side</p>
      <p class="g-pstyle2">of the car.</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.6145%;margin-top:-8.5px;left:67.4609%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:78.5163%;margin-top:-9.1px;left:63.6973%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle2">First shot</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-video3-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.9910901315622;"
    data-aspect-ratio="0.991"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-video3-md-img"
      class="g-video3-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video3-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.4961%;margin-top:-9.6px;left:63.0398%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:8.9595%;margin-top:-17.7px;right:32.9994%;width:144px;"
    >
      <p class="g-pstyle1">ICE agent 1 draws</p>
      <p class="g-pstyle1">the gun.</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:14.5156%;margin-top:-17.7px;right:50.3075%;width:129px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
      <p class="g-pstyle1">moves forward.</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:35.983%;margin-top:-9.6px;left:63.0523%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:42.7466%;margin-top:-17.7px;left:58.9925%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle2">Steps to the side</p>
      <p class="g-pstyle2">of the car.</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.521%;margin-top:-9.6px;left:63.0558%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:78.4109%;margin-top:-9.2px;left:60.1227%;margin-left:-43.5px;width:87px;"
    >
      <p class="g-pstyle2">First shot</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-video3-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 4.42857142857143;"
    data-aspect-ratio="4.429"
    data-min-width="930"
  >
    <div
      id="g-video3-lg-img"
      class="g-video3-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video3-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9631%;margin-top:-9.6px;left:30.3185%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9631%;margin-top:-9.6px;left:59.262%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9631%;margin-top:-9.6px;left:88.1965%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:28.4115%;margin-top:-17.7px;right:68.0656%;width:125px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
      <p class="g-pstyle1">draws the gun.</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:28.4115%;margin-top:-17.7px;left:56.3808%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle2">Steps to the side</p>
      <p class="g-pstyle2">of the car.</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:31.9829%;margin-top:-9.2px;left:86.2579%;margin-left:-43.5px;width:87px;"
    >
      <p class="g-pstyle2">First shot</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:45.0781%;margin-top:-17.7px;right:80.3461%;width:129px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
      <p class="g-pstyle1">moves forward.</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 17:00 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 17:00 -->
<!-- ai file: video3.ai -->
<style lang="scss">
  #g-video3-box {
    container-type: inline-size;
    container-name: g-video3-box;
  }
  #g-video3-box,
  #g-video3-box .g-artboard {
    margin: 0 auto;
  }
  #g-video3-box p {
    margin: 0;
  }
  #g-video3-box .g-aiAbs {
    position: absolute;
  }
  #g-video3-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-video3-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-video3-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-video3-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-video3-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-video3-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-video3-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-video3-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-video3-lg {
        display: block !important;
      }
    }
  }
  #g-video3-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video3-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 136, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video3-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video3-xs .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: right;
  }
  #g-video3-xs .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-video3-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video3-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 136, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video3-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video3-sm .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: right;
  }
  #g-video3-sm .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-video3-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video3-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 136, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video3-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video3-md .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: right;
  }
  #g-video3-md .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-video3-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video3-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 136, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video3-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video3-lg .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: right;
  }
  #g-video3-lg .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
